"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationDefault = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const moment_1 = __importDefault(require("moment"));
;
const react_1 = require("react");
const mobx_react_1 = require("mobx-react");
const CheckinApi_1 = __importDefault(require("../../api/CheckinApi"));
const react_bootstrap_1 = require("react-bootstrap");
const lodash_1 = require("lodash");
const ValidationError_1 = __importDefault(require("../../common/form/ValidationError"));
const hui_1 = require("@mit/hui");
exports.validationDefault = {
    valid: true,
    validationText: ''
};
const MedicalLocationTimesComponent = ({ covidNav }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [locations, setLocations] = (0, react_1.useState)(undefined);
    const [initialLocations, setInitialLocations] = (0, react_1.useState)(undefined);
    const [initialLocationTimes, setInitialLocationTimes] = (0, react_1.useState)(undefined);
    const [errorText, setErrorText] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        CheckinApi_1.default.fetchLocations().then((data) => __awaiter(void 0, void 0, void 0, function* () {
            setErrorText('');
            if (!data.error) {
                if (data.locations) {
                    setInitialLocations((0, lodash_1.cloneDeep)(data.locations));
                    let locationPromises = yield data.locations.map((location) => __awaiter(void 0, void 0, void 0, function* () {
                        let c = yield CheckinApi_1.default.fetchLocationTimes(location.id);
                        if (!c.error) {
                            location.times = c.times;
                        }
                        else {
                            setErrorText('Error retrieving locations times.');
                            setIsLoading(false);
                        }
                        return location;
                    }));
                    Promise.all(locationPromises).then(locations => {
                        setLocations(locations);
                        setIsLoading(false);
                        let locTimes = locations.map((loc) => {
                            return loc.times;
                        });
                        const flattenedLocTimes = [].concat(...locTimes);
                        setInitialLocationTimes((0, lodash_1.cloneDeep)(flattenedLocTimes));
                    }).catch((error) => {
                        setErrorText('Error retrieving locations times.');
                        setIsLoading(false);
                    });
                }
            }
            else {
                setErrorText('Error retrieving locations.');
                setIsLoading(false);
            }
        })).catch((error) => {
            setErrorText('Error retrieving locations.');
            setIsLoading(false);
        });
    }, []);
    const renderRow = (location, index) => {
        const clickCheckBox = (event) => {
            let locationsCopy = [...locations];
            locationsCopy[index].medical_queue_indicator = !locationsCopy[index].medical_queue_indicator;
            setLocations(locationsCopy);
            setErrorText('');
        };
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", Object.assign({ className: 'medical-title-col' }, { children: (0, jsx_runtime_1.jsx)("strong", { children: location.name }) })), (0, jsx_runtime_1.jsx)("td", {}), (0, jsx_runtime_1.jsx)("td", { children: renderOpen(index, "mon", location.times) }), (0, jsx_runtime_1.jsx)("td", { children: renderOpen(index, "tue", location.times) }), (0, jsx_runtime_1.jsx)("td", { children: renderOpen(index, "wed", location.times) }), (0, jsx_runtime_1.jsx)("td", { children: renderOpen(index, "thu", location.times) }), (0, jsx_runtime_1.jsx)("td", { children: renderOpen(index, "fri", location.times) }), (0, jsx_runtime_1.jsx)("td", { children: renderOpen(index, "sat", location.times) }), (0, jsx_runtime_1.jsx)("td", { children: renderOpen(index, "sun", location.times) })] }), (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsxs)("td", Object.assign({ className: 'medical-indicator-col' }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ onClick: clickCheckBox }, { children: [(0, jsx_runtime_1.jsx)("input", { className: 'medical-checkbox', type: 'checkbox', checked: location.medical_queue_indicator, readOnly: true }), (0, jsx_runtime_1.jsx)("span", {})] })), "  Wait time indicator"] })), (0, jsx_runtime_1.jsx)("td", Object.assign({ className: 'medical-open-col' }, { children: "Open at" })), renderDay(index, true, "mon", location.times), renderDay(index, true, "tue", location.times), renderDay(index, true, "wed", location.times), renderDay(index, true, "thu", location.times), renderDay(index, true, "fri", location.times), renderDay(index, true, "sat", location.times), renderDay(index, true, "sun", location.times)] }), (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", {}), (0, jsx_runtime_1.jsx)("td", Object.assign({ className: 'medical-open-col' }, { children: "Close at" })), renderDay(index, false, "mon", location.times), renderDay(index, false, "tue", location.times), renderDay(index, false, "wed", location.times), renderDay(index, false, "thu", location.times), renderDay(index, false, "fri", location.times), renderDay(index, false, "sat", location.times), renderDay(index, false, "sun", location.times)] }), (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 9 }, { children: (0, jsx_runtime_1.jsx)("div", { className: 'medical-horizontal-line' }) })) })] }));
    };
    const renderOpen = (arrIndex, dayOfWeek, dayObj) => {
        let locationTimes = dayObj.find(x => x.day_of_week.toLowerCase() === dayOfWeek.toLowerCase());
        const clickCheckBox = (event) => {
            let locationsCopy = [...locations];
            let locationCopy = Object.assign({}, locations[arrIndex]);
            let locationCopyTimeIndex = dayObj.findIndex(x => x.day_of_week.toLowerCase() === dayOfWeek.toLowerCase());
            let currentTimes = locationCopy.times[locationCopyTimeIndex];
            locationCopy.times[locationCopyTimeIndex] = Object.assign(Object.assign({}, locationTimes), { is_open: !currentTimes.is_open });
            setLocations(locationsCopy);
            setErrorText('');
        };
        if (locationTimes !== undefined) {
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'form-check operating-hours-check' }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ onClick: clickCheckBox }, { children: [(0, jsx_runtime_1.jsx)("input", { className: 'form-check-input medical-checkbox', type: 'checkbox', checked: locationTimes.is_open, readOnly: true }), (0, jsx_runtime_1.jsx)("span", {})] })), "Open"] })));
        }
    };
    const save = () => {
        setIsLoading(true);
        let changedLocs = locations.filter((item) => {
            let initialItem = initialLocations.find((x) => (x.id === item.id));
            return (item.name !== initialItem.name) ||
                (item.medical_queue_indicator !== initialItem.medical_queue_indicator);
        });
        let locationPost = [];
        if (changedLocs.length > 0) {
            locationPost = changedLocs.map((loc) => {
                return CheckinApi_1.default.putLocation(loc);
            });
        }
        Promise.all(locationPost).then(result => {
            //Update initialLocations
            changedLocs.forEach((item) => {
                let initialItem = initialLocations.find((x) => (x.id === item.id));
                let res = result.find((x) => (x.id === item.id));
                if (!res.error) {
                    initialItem.name = item.name;
                    initialItem.medical_queue_indicator = item.medical_queue_indicator;
                }
                else {
                    setErrorText('Error updating locations.');
                }
            });
            let locTimes = locations.map((loc) => {
                return loc.times;
            });
            let allLocTimes = [].concat(...locTimes);
            let changedLocTimes = allLocTimes.filter((item) => {
                let initialItem = initialLocationTimes.find((x) => (x.location_id === item.location_id) && (x.day_of_week.toLowerCase() === item.day_of_week.toLowerCase()));
                return (item.is_open !== initialItem.is_open) ||
                    (item.open_time.format("HH:mm:ss") !== initialItem.open_time.format("HH:mm:ss")) ||
                    (item.close_time.format("HH:mm:ss") !== initialItem.close_time.format("HH:mm:ss"));
            });
            if (changedLocTimes.length > 0) {
                CheckinApi_1.default.putLocationOperatingHoursBatch(changedLocTimes).then(res => {
                    if (!res.error) {
                        //Update initialLocationTimes
                        changedLocTimes.forEach((item) => {
                            let initialItem = initialLocationTimes.find((x) => (x.location_id === item.location_id) && (x.day_of_week.toLowerCase() === item.day_of_week.toLowerCase()));
                            initialItem.is_open = item.is_open;
                            initialItem.open_time = (0, lodash_1.cloneDeep)(item.open_time);
                            initialItem.close_time = (0, lodash_1.cloneDeep)(item.close_time);
                        });
                        setErrorText('Success');
                    }
                    else {
                        setErrorText('Error updating location times.');
                    }
                    setIsLoading(false);
                }).catch((error) => {
                    setErrorText('Error updating location times.');
                    setIsLoading(false);
                });
            }
            else {
                setIsLoading(false);
                setErrorText('Success');
            }
        }).catch((error) => {
            setErrorText('Error updating locations.');
            setIsLoading(false);
        });
    };
    const renderDay = (arrIndex, isOpen, dayOfWeek, dayObj) => {
        let timeToChange = isOpen ? "open_time" : "close_time";
        let locationTimes = dayObj.find(x => x.day_of_week.toLowerCase() === dayOfWeek.toLowerCase());
        const changeTime = (newTime) => {
            const newTimeValue = (0, moment_1.default)(newTime, "HH:mm");
            let locationsCopy = [...locations];
            let locationCopy = Object.assign({}, locations[arrIndex]);
            let locationCopyTimeIndex = dayObj.findIndex(x => x.day_of_week.toLowerCase() === dayOfWeek.toLowerCase());
            locationCopy.times[locationCopyTimeIndex] = Object.assign(Object.assign({}, locationTimes), { [timeToChange]: newTimeValue });
            setLocations(locationsCopy);
            setErrorText('');
        };
        if (locationTimes !== undefined) {
            let isVisible = locationTimes.is_open;
            if (isOpen) {
                if (isVisible) {
                    return (0, jsx_runtime_1.jsx)("td", Object.assign({ className: 'medical-time-col' }, { children: (0, jsx_runtime_1.jsx)(hui_1.TimePicker, { onChange: changeTime, value: locationTimes[timeToChange].format("HH:mm") }) }));
                }
                else {
                    return (0, jsx_runtime_1.jsx)("td", Object.assign({ className: 'medical-title-col-closed', rowSpan: 2 }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'medical-title-col-closed-text' }, { children: "Closed" })) }));
                }
            }
            else {
                if (isVisible) {
                    return (0, jsx_runtime_1.jsx)("td", Object.assign({ className: 'medical-time-col' }, { children: (0, jsx_runtime_1.jsx)(hui_1.TimePicker, { onChange: changeTime, value: locationTimes[timeToChange].format("HH:mm") }) }));
                }
            }
        }
    };
    return (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'page-content' }, { children: [isLoading && (0, jsx_runtime_1.jsx)(hui_1.SkeletonLoader, { type: 'table' }), !isLoading &&
                    (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Table, Object.assign({ borderless: true, size: "sm" }, { children: [(0, jsx_runtime_1.jsxs)("thead", { children: [(0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", {}), (0, jsx_runtime_1.jsx)("th", {}), (0, jsx_runtime_1.jsx)("th", { children: "Monday" }), (0, jsx_runtime_1.jsx)("th", { children: "Tuesday" }), (0, jsx_runtime_1.jsx)("th", { children: "Wednesday" }), (0, jsx_runtime_1.jsx)("th", { children: "Thursday" }), (0, jsx_runtime_1.jsx)("th", { children: "Friday" }), (0, jsx_runtime_1.jsx)("th", { children: "Saturday" }), (0, jsx_runtime_1.jsx)("th", { children: "Sunday" })] }), (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 9 }, { children: (0, jsx_runtime_1.jsx)("div", { className: 'medical-horizontal-line' }) })) })] }), locations && locations.map((row, index) => {
                                return (0, jsx_runtime_1.jsx)("tbody", { children: renderRow(row, index) }, `tbody-${index}`);
                            }), (0, jsx_runtime_1.jsx)("tbody", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", Object.assign({ colSpan: 8 }, { children: (0, jsx_runtime_1.jsx)(ValidationError_1.default, { text: errorText }) })), (0, jsx_runtime_1.jsxs)("td", { children: [" ", (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary, onClick: save, text: "Save" })] })] }) })] }))] })) });
};
const MedicalLocationTimes = (0, mobx_react_1.inject)('covidNav')((0, mobx_react_1.observer)(MedicalLocationTimesComponent));
exports.default = MedicalLocationTimes;
